<mat-dialog-actions>
    <button class="mat-button"
    style="color: #00b7cf; outline: none;"  (click)="onCloseClick()">
    <mat-icon>close</mat-icon></button>
  
  
    </mat-dialog-actions>
  
    <mat-dialog-content>
  
        <app-shopify [body]="body" [dialogRef]="DialogRef"></app-shopify>
  
  </mat-dialog-content>
  